import React, { useContext } from 'react';
import styled from 'styled-components';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { Link } from 'gatsby';
import { Markup } from 'interweave';
import { useEventData } from 'hooks';
import { LocalContext } from 'context';

export default () => {
  const { edges: events } = useEventData();
  const { theme } = useContext(LocalContext);

  const futureEvents = events
    .filter(({ node }) => node.frontmatter.status === 'future' && !node.frontmatter.hidden)
    .sort((a, b) => b.node.frontmatter.id - a.node.frontmatter.id);
  return (
    <FutureEvents>
      {futureEvents.map((event) => {
        const eventImage = getImage(event.node.frontmatter.thumb);
        return (
          <Event key={event.node.frontmatter.id}>
            <GatsbyImage image={eventImage} alt={event.node.frontmatter.name} />
            <Details $theme={theme}>
              <h4>
                <Markup content={event.node.frontmatter.dates} />
              </h4>
              <h3>{event.node.frontmatter.name}</h3>
              <p>{event.node.frontmatter.description}</p>
              <Link to={event.node.frontmatter.slug}>View Event</Link>
            </Details>
          </Event>
        );
      })}
    </FutureEvents>
  );
};

const Details = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  font-family: 'Open Sans', sans-serif;
  justify-content: flex-start;
  h3 {
    color: ${({ $theme }) => $theme.textColor};
    font-size: 2.5rem;
    font-weight: 400;
    margin: 0;
    margin-bottom: 0.5em;
  }
  h4 {
    color: ${({ $theme }) => $theme.textColor};
    font-size: 1.25rem;
    font-weight: 600 !important;
    margin-bottom: 1em !important;
    text-align: left !important;
    width: 100% !important;
  }
  p {
    color: ${({ $theme }) => $theme.textColor} !important;
    font-size: 1rem;
    margin-bottom: 1em !important;
    text-align: left !important;
    width: 100% !important;
  }
  a {
    background-color: ${({ $theme }) => $theme.fg};
    border-radius: 3rem;
    color: white;
    font-size: 1rem;
    font-weight: 600;
    margin-bottom: 0.5em;
    padding: 0.75rem 1.5rem;
    text-transform: uppercase;
    transition: 0.3s;
    &:hover {
      background-color: ${({ $theme }) => $theme.textColor};
    }
  }
`;

const Event = styled.div`
  background: white;
  display: grid;
  grid-gap: 3rem;
  grid-template-columns: 1fr;
  padding: 1.25rem;
  img {
    max-width: 100%;
    object-position: top left !important;
  }
  @media (min-width: 768px) {
    grid-template-columns: 20rem 1fr;
  }
`;

const FutureEvents = styled.div`
  background: white;
  height: auto;
  width: 100%;
`;
